export const TYPE_ID = 2;
